import { PaymentMethodsType } from '../payment';
import { ShippingAddress } from '../shipping';
import { AdditionalProductFee, CouponMessage } from '../shoppingCart';

export enum CheckoutStepsType {
  CheckoutLogin = '/checkout/login',
  ShippingAddress = '/checkout/shipping-address',
  ShippingOptions = '/checkout/shipping-options',
  Payments = '/checkout/payments',
  Review = '/checkout/review',
  OrderSetUp = '/checkout/order-set-up',
}

export type CheckoutSummaryData = {
  orderSummary: CheckoutOrderSummary;
  orderDetails: { items: number };
  shippingSummary?: CheckoutShippingSummary;
  paymentSummary?: {
    paymentMethods: Array<CheckoutPaymentSummary>;
  };
};

export type CheckoutOrderSummary = {
  subTotal: number;
  giftCard: number | null;
  bullseyeBucks: number | null;
  shipping: number | null;
  tax: number | null;
  state: string;
  country: string;
  total: number | null;
  couponDiscount: number | null;
  signatureRequired: number | null;
  wireTransferFee: number | null;
  bundleDiscount: number | null;
  additionalProductFees: Array<AdditionalProductFee> | null;
  autoApplyCouponResponse?: {
    couponNumber: string;
    autoCouponDiscount: number;
  } | null;
  applyCouponMessage: CouponMessage | null;
  totalDue?: number;
};

export type CheckoutShippingSummary = {
  shippingAddress: ShippingAddress;
  billingAddress: ShippingAddress;
  shippingMethods: Array<ShippingMethod>;
  email: string | null;
};

export type CheckoutPaymentSummary = {
  paymentMethod?: PaymentMethodType;
};

export type PaymentMethodType = {
  cardVendor: string;
  last4: string;
  type: PaymentMethodsType;
};

type ShippingMethod = {
  sum: number;
};

export type SubmitOrder = Array<{
  orderNumber: number;
  masterOrderId?: number;
  itemTotal: number;
  shippingTotal: number;
  taxTotal: number;
  orderTotal: number;
  products: Array<SubmitOrderProduct>;
  vendorName: string;
}>;

export type SubmitOrderComment = {
  orderId: number;
  orderComment: string;
};

export type SubmitOrderProduct = {
  sku: string;
  quantity: number;
  price: number;
  name: string;
  brand?: string;
  category?: string;
  variant?: string;
};

export type PaymentProfile = {
  cardNumber: string;
  expirationDate: string;
  cardType: string;
  issuerNumber: string;
};
